import { render, staticRenderFns } from "./AppKeypoint.vue?vue&type=template&id=ad8f24b4&"
import script from "./AppKeypoint.vue?vue&type=script&lang=js&"
export * from "./AppKeypoint.vue?vue&type=script&lang=js&"
import style0 from "./AppKeypoint.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports